import { useEffect, useState } from "react"
import sharedService from "../../../Services/SharedService"
import { BOXGROUP_ID, groupBR } from "../../../Utils/const"
import DialogNoti from "../../Components/ModalNoti/DialogNoti"

const ParamsComponent = () => {
    const [group, setGroup] = useState({})
    const [isEditing, setIsEditing] = useState(false)
    const [editedGroup, setEditedGroup] = useState({})
    const [modal, setModal] = useState({ open: false, title: "", message: "" })
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user?.role === "admin") {
            setIsAdmin(true);
        }
    }, [])

    useEffect(() => {
        getGroup()
    }, [])

    function getGroup() {
        sharedService.getBoxGroup(BOXGROUP_ID).then(res => {
            const data = res.data
            setGroup({ ...data })
        }).catch(e => console.log(e))
    }

    function handleEdit() {
        setEditedGroup({
            ...group,
            params: group.params?.map(param => [...param]) || []
        })
        setIsEditing(true)
    }

    function handleParamChange(rowIndex, columnIndex, value) {
        setEditedGroup(currentGroup => ({
            ...currentGroup,
            params: currentGroup.params.map((param, index) => {
                if (index !== rowIndex) return param

                const updatedParam = [...param]
                updatedParam[columnIndex] = value
                return updatedParam
            })
        }))
    }

    function handleAddParam(rowIndex) {
        setEditedGroup(currentGroup => {
            const params = [...(currentGroup.params || [])]
            params.splice(rowIndex + 1, 0, ["", "", "", ""])
            return { ...currentGroup, params }
        })
    }

    function handleDeleteParam(rowIndex) {
        setEditedGroup(currentGroup => ({
            ...currentGroup,
            params: currentGroup.params.filter((_, index) => index !== rowIndex)
        }))
    }

    function handleTemporarySave() {
        sharedService.updateBoxGroup(BOXGROUP_ID, editedGroup)
            .then(() => {
                setGroup(editedGroup)
                console.log(editedGroup)
                setIsEditing(false)
                setModal({ open: true, title: "Thông báo", message: "Cập nhật thông số kỹ thuật thành công!" })
            })
            .catch(e => {
                console.log(e)
                setModal({ open: true, title: "Thông báo", message: "Cập nhật thông số kỹ thuật thất bại!" })
            })
    }

    function handleCancel() {
        setIsEditing(false)
        setEditedGroup({})
    }

    const displayedGroup = isEditing ? editedGroup : group

    return <div className="ParamsComponent">
        {modal.open && <DialogNoti modal={modal} functionCallBack={() => setModal({ ...modal, open: false })} />}
        <table>
            <thead>
                <tr>
                    <th className="center">TT</th>
                    <th className="center">Thông số kỹ thuật</th>
                    <th className="center">Đơn vị tính</th>
                    <th className="center">{groupBR.find(g => g.id === BOXGROUP_ID)?.name}</th>
                    {isEditing && <th className="center">Thao tác</th>}
                </tr>
            </thead>
            <tbody>
                {displayedGroup.params?.length > 0 && displayedGroup.params.map((p, i) =>
                    <tr key={i}>
                        {[0, 1, 2, 3].map(columnIndex =>
                            <td className={columnIndex === 1 ? "" : "center"} key={columnIndex}>
                                {isEditing
                                    ? <input
                                        value={p?.[columnIndex] ?? ""}
                                        onChange={event => handleParamChange(i, columnIndex, event.target.value)}
                                    />
                                    : p?.[columnIndex]}
                            </td>
                        )}
                        {isEditing && <td className="row-actions">
                            <button type="button" className="btn btn-secondary" onClick={() => handleAddParam(i)}>+</button>
                            <button type="button" className="btn btn-danger" onClick={() => handleDeleteParam(i)}>-</button>
                        </td>}
                    </tr>
                )}
            </tbody>
        </table>

        {isAdmin && (
            <div className="actions">
                {!isEditing
                    ? <button type="button" className="btn btn-secondary" onClick={handleEdit}>Sửa thông tin</button>
                    : <>
                        <div>
                            <button type="button" className="btn btn-secondary" onClick={handleTemporarySave}>Lưu thông tin</button>
                        </div>
                        <div>
                            <button type="button" className="btn btn-danger" onClick={handleCancel}>Huỷ</button>
                        </div>
                    </>}
            </div>
        )}
    </div>
}

export default ParamsComponent